<template>
  <div :class="$options.name">
    <v-card>
      <object-form-create-form
        :data="single"
        is-edit
        @submit="onUpdate"
      />
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ObjectFormCreateForm from '@/views/settings/object-form/components/ObjectForm.vue';

export default {
  name: 'object-form-item',
  asyncData({ store, route }) {
    const { id } = route.params;

    const actions = [
      store.dispatch('objectForms/getItem', id),
    ];

    return Promise.all(actions);
  },
  components: { ObjectFormCreateForm },
  data: () => ({
    form: null,
  }),
  computed: {
    ...mapState('objectForms', ['single']),
  },
  methods: {
    ...mapActions('objectForms', ['update']),
    ...mapActions(['showNotify']),
    async onUpdate(form) {
      this.isLoading = true;
      try {
        await this.update(form);
        this.showNotify({ message: 'Форма успешно обновлена' });
      } catch (e) {
        this.showNotify({ type: 'error', message: 'Что-то пошло не так' });
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>

</style>
